import { AgGridReact } from "@ag-grid-community/react";
import { useOnetoOneNotes } from "../../../Hooks/Features/Overview/useOnetoOneNotes";
import { calculateWordsFromString } from "../../../utils/Helper";
import { SkeletonDataTable } from "../../Loader/Loader";

const OnetoOneNotes = ({notesUser, setNotesFlag}) => {

    const { notesRowData, notesColDef, submitNotes, notesLoader, notesData, setNotesData } = useOnetoOneNotes({notesUser, setNotesFlag});

    return (
        <div>
            <div>Enter Description: </div>
            <div>
                <textarea className="w100" style={{ resize: "none" }} rows={5} value={notesData?.notes} onChange={(e) => setNotesData((prev) => ({ ...prev, notes: e.target.value }))} />
            </div>
            <div className="d-flex justify-content-between w100">
                {calculateWordsFromString(notesData?.notes) <= 20 && <span className="w20">{calculateWordsFromString(notesData?.notes)}/20 words</span>}
                <div className="text-right w100">
                    <button className="button btn-default" onClick={() => setNotesData((prev) => ({ ...prev, notes: "" }))}>Reset</button>
                    {notesLoader?.btn ?
                        <button className="button btn-primary" style={{ width: "65px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                        <button className="button btn-primary" style={{ width: "65px" }} onClick={() => submitNotes()}>Submit</button>
                    }
                </div>
            </div>
            {notesRowData?.length > 0 &&
                <div style={{ height: "30vh" }} className="ag-theme-alpine mt-2">
                    {notesLoader?.grid ? <SkeletonDataTable numSkeletons={7} /> :
                        <AgGridReact rowData={notesRowData} columnDefs={notesColDef} headerHeight={30} rowHeight={30} />
                    }
                </div>
            }
        </div>
    )
}

export default OnetoOneNotes;